import { useChatModeStore } from '../../../../controllers/chat-mode-store/useChatModeStore';

/**
 * Reactively reads the per-key `useCurrentPageContext` user preference from the
 * chat-mode store, i.e. whether the current page should be used as chat context.
 *
 * Unlike the imperative `getChatMode(key).useCurrentPageContext` getter exposed
 * by `useChatModeStoreActions` (which takes a render-time snapshot and does NOT
 * subscribe to store updates), this hook subscribes to the store slice for
 * `key`. Consumers therefore re-render when the preference changes — e.g. when
 * the user clicks the context banner's "X" (Remove context) button, which calls
 * `setUseCurrentPageContext(key, false)`.
 */
export const useCurrentPageContextEnabled = (key: string): boolean => {
	const [{ useCurrentPageContext }] = useChatModeStore(key);
	return useCurrentPageContext;
};
